import React, { useEffect, useState } from "react";
import {
  getUserP2PAds,
  getUserP2POrders,
} from "../../../../../store/Actions/P2PActions";
import { connect } from "react-redux";
import { P2PTableHeaderStyle, P2PTableStyle } from "./UserP2P.styled";
import { P, SubHeader } from "../../../../../UI toolkit/Text/Text";
import {
  capitalizeFirstLetter,
  groupActivitiesByDaysOrMonth,
} from "../../../../../utils/specialFunctions";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import ic_sent_icon from "../../../../../assets/images/ic-sent-coin.svg";
import ic_receive_icon from "../../../../../assets/images/ic-received-coin.svg";
import ic_swapped_coin from "../../../../../assets/images/ic-swapped-coin.svg";
import { Badge } from "../../../../../UI toolkit/Button/Button";
import moment from "moment";
import UserP2POrderModal from "./UserP2POrderModal";

TimeAgo.addLocale(en);
const timeAgo = new TimeAgo("en-US");

const UserP2POrdersTable = ({ getOrders, orders, userId, user }) => {
  const [order, setOrder] = React.useState(null);
  const [openModal, setopenModal] = useState(false);

  useEffect(() => {
    getOrders(userId);
  }, [getOrders, orders]);

  const statusKeys = {
    stopped: "broken",
    active: "ongoing",
    completed: "completed",
    pending: "unclaimed",
    paid: "claimed",
  };

  const bgColor = (status) => {
    return status === "active" || status === "pending"
      ? "#FFEAB6"
      : status === "completed" || status === "paid"
      ? "#D1F7C4"
      : status === "failed"
      ? "#FFDCE5"
      : "";
  };

  const color = (status) => {
    return status === "active" || status === "pending"
      ? "#606060"
      : status === "completed" || status === "paid"
      ? "#606060"
      : status === "failed"
      ? "#531423"
      : "";
  };

  return (
    <div style={{ overflowX: "auto" }}>
      <P2PTableHeaderStyle className="w-full">
        <tbody className="w-full">
          <tr className="Table-heading -px-1.5">
            <td width="10%" className="pt-4 pb-4"></td>
            <td width="10%" className="pt-4 pb-4"></td>
            <td width="20%" className="pt-4 pb-4">
              <div className="flex justify-center">
                <SubHeader fontSize="12px" color={"#7C8191"} fontWeight="500">
                  USER
                </SubHeader>
              </div>
            </td>
            <td width="15%" className="pt-4 pb-4">
              <div className="flex justify-center">
                <SubHeader fontSize="12px" color={"#7C8191"} fontWeight="500">
                  TRADE RATE
                </SubHeader>
              </div>
            </td>
            <td width="15%" className="pt-4 pb-4">
              <div className="flex justify-center">
                <SubHeader fontSize="12px" color={"#7C8191"} fontWeight="500">
                  QUANTITY
                </SubHeader>
              </div>
            </td>
            <td width="15%" className="pt-4 pb-4">
              <div className="flex justify-center">
                <SubHeader fontSize="12px" color={"#7C8191"} fontWeight="500">
                  MERCHANT
                </SubHeader>
              </div>
            </td>
            <td width="30%" className="w-full pt-4 pb-4 pr-6"></td>
          </tr>
        </tbody>
      </P2PTableHeaderStyle>
      {/* <pre>{JSON.stringify(orders, null, 2)}</pre> */}
      {groupActivitiesByDaysOrMonth(orders ? orders : null, "days") &&
        groupActivitiesByDaysOrMonth(orders ? orders : null, "days").map(
          (transactionGroup, idx, arr) => {
            return (
              <P2PTableStyle className="w-full" key={idx}>
                <div></div>
                <tbody>
                  <tr>
                    <td colSpan="5">
                      <div className="pt-4 pb-4 px-1.5">
                        <P fontSize="13px" color={"#7C8191"} fontWeight="500">
                          {`${timeAgo.format(
                            new Date(transactionGroup.group)
                          )} — ${new Date(
                            transactionGroup.group
                          ).toDateString()}`}
                        </P>
                      </div>
                    </td>
                  </tr>

                  {transactionGroup.data.map((curr, idx, arr) => {
                    return (
                      // <pre>{JSON.stringify(curr, null, 2)}</pre>
                      <tr
                        className="px-1.5"
                        style={{ borderBottom: "1px solid #EFF0F5" }}
                        key={idx}
                      >
                        <td width="15%" className="pt-4 pb-4 px-1.5">
                          <Badge
                            color={color(curr.status)}
                            bg={bgColor(curr.status)}
                          >
                            {curr.status}
                          </Badge>
                        </td>
                        <td width="15%">
                          <div className="flex justify-center items-start">
                            <P
                              fontSize="13px"
                              color={"#374072"}
                              fontWeight="500"
                            >
                              {curr?.ad?.action === "buy" ? "Buy" : "Sell"}
                            </P>
                          </div>
                        </td>

                        <td width="15%">
                          <div className="">
                            <P
                              fontSize="13px"
                              color={"#374072"}
                              fontWeight="500"
                            >
                              {user.email}
                            </P>
                          </div>
                        </td>
                        <td width="15%">
                          <div className="flex justify-center items-start">
                            <P
                              fontSize="13px"
                              color={"#374072"}
                              fontWeight="500"
                            >
                              NGN {curr?.price}/ USDT
                            </P>
                          </div>
                        </td>
                        <td width="15%">
                          <div className="flex justify-center">
                            <div>
                              <P
                                fontSize="13px"
                                color={"#374072"}
                                fontWeight="500"
                              >
                                {`${
                                  curr?.ad?.action === "sell"
                                    ? curr?.ad.source_currency
                                    : curr?.ad?.action === "buy"
                                    ? curr?.ad?.destination_currency
                                    : ""
                                }${Number(curr?.quantity).toFixed(2)}`}
                              </P>
                              <P
                                fontSize="10px"
                                color={"#374072"}
                                fontWeight="500"
                              >
                                NGN
                                {Number(curr?.quantity * curr?.price)
                                  .toFixed(2)
                                  .toLocaleString()}
                              </P>
                            </div>
                          </div>
                        </td>
                        <td width="15%">
                          <div className="flex justify-center">
                            <div>
                              <P
                                fontSize="13px"
                                color={"#7A809B"}
                                fontWeight="400"
                              >
                                {curr?.ad?.account?.email}
                              </P>
                              <P
                                fontSize="10px"
                                color={"#7A809B"}
                                fontWeight="500"
                              >
                                {curr?.ad?.p2p_profile?.username}
                              </P>
                            </div>
                          </div>
                        </td>
                        <td width="15%" className="pt-4 pb-4 px-1.5">
                          <div className="flex justify-center">
                            <div className="">
                              <P
                                fontSize="13px"
                                color={"#0087B5"}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setOrder(curr);
                                  setopenModal(true);
                                }}
                              >
                                View
                              </P>
                            </div>
                          </div>
                        </td>
                        <td width="15%" className="pt-4 pb-4 px-1.5">
                          <div className="flex justify-center"></div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </P2PTableStyle>
            );
          }
        )}

      <div>
        {openModal ? (
          <UserP2POrderModal
            width={"30%"}
            border={"none"}
            closeModalCallback={() => {
              setopenModal(false);
            }}
            order={order}
            user={user}
          />
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.p2p.loading,
    error: state.p2p.error,
    orders: state.p2p.userP2POrders,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getOrders: (query) => dispatch(getUserP2POrders(query)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserP2POrdersTable);
